<template>
    <el-dialog
        class="reprove-dialog"
        destroy-on-close
        show-close
        :title="translate('words.reprove')"
        :visible.sync="visible"
    >
        <div class="reprove-dialog__content">
            <h3>{{ translate('messages.dialog_reprove.contract_basic_data') }}</h3>
            <p>{{ translate('messages.dialog_reprove.contract_number') }}: <strong>{{ report.contract_number }}</strong></p>
            <p>{{ translate('messages.dialog_reprove.contract_volume') }}: <strong>{{ report.volume }}</strong></p>
            <p>{{ translate('messages.dialog_reprove.cultivation') }}: <strong>{{ report.cultivation }}</strong></p>
            <p>{{ translate('messages.dialog_reprove.reseller') }}: <strong>{{ report.client }}</strong></p>
            <div style="margin-top: 8px"/>
            <h3>{{ translate('messages.dialog_reprove.farms') }}</h3>
            <p>{{ translate('messages.dialog_reprove.total_farms') }}: <strong>{{ report.properties.length }}</strong></p>
            <div style="margin-top: 8px"/>
            <h3>{{ translate('messages.dialog_reprove.reason') }}</h3>
            <p>{{ translate('messages.dialog_reprove.contract_basic_data') }}</p>
            <el-select v-model="form.reason" clearable style="width: 100%">
                <el-option
                    label="Volume incompleto"
                    value="VOLUME_INCOMPLETO"
                ></el-option>
                <el-option
                    label="Alteração no contrato"
                    value="ALTERACAO_CONTRATO"
                ></el-option>
                <el-option label="Outros" value="OUTROS"></el-option>
            </el-select>
            <el-input
                type="textarea"
                rows="4"
                v-if="form.reason === 'OUTROS'"
                v-model="form.justification"
                :placeholder="
                    translate('messages.dialog_reprove.reason_placeholder')
                "
                clearable
            />
        </div>
        <div class="actions">
            <el-button @click="visible = false"
                >{{ translate('words.cancel') }}
            </el-button>
            <el-button :disabled="!isValid" @click="confirmReprove()" type="primary"
                >{{ translate('words.confirm') }}
            </el-button>
        </div>
    </el-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'DialogReprove',
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            form: {
                reason: '',
                justification: ''
            }
        };
    },
    computed: {
        ...mapState('traceabilityContractModule', ['report']),
        visible: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            }
        },
        isValid() {
            if (this.form.reason === 'OUTROS') {
                return this.form.reason && this.form.justification;
            }
            return this.form.reason;
        }
    },
    methods: {
        ...mapActions('traceabilityContractModule', ['reportReprove']),
        translate(key, params = {}) {
            const base = 'contrato_rastreabilidade';
            return this.$t(`${base}.${key}`, params);
        },
        confirmReprove() {
            const params = {
                reportId: this.$route.params.id,
                reason: this.form.reason,
                justification: this.form.justification
            };

            this.reportReprove(params)
                .then(() => {
                    this.$notify.success(
                        this.translate(
                            'messages.dialog_reprove.reproved_successfully'
                        )
                    );
                    this.$router.push({
                        name: 'contrato-rastreabilidade'
                    });
                })
                .catch(() => {
                    this.$notify.error(
                        this.translate('messages.dialog_reprove.reproved_error')
                    );
                });
        }
    }
};
</script>

<style scoped lang="scss">
.reprove-dialog {
    .reprove-dialog__content {
        margin-top: 16px;

        h3 {
            margin: 0;
            color: #3b3b3b;
            font-weight: 500;
            font-size: 16px;
        }

        p {
            margin: 0;
            color: #3b3b3b;
            font-weight: 400;
            font-size: 14px;
        }

        display: flex;
        flex-direction: column;
        gap: 8px;
    }

    .actions {
        margin-top: 16px;
        display: flex;
        justify-content: flex-end;
        gap: 16px;
    }
}
</style>
